import httpClient from 'src/common/axios/config'
import { UpdateWhitelistBankDetailsPayload, WhitelistBankDetails } from './models'

export const getWhitelistPaymentDetails = (memberId: string) =>
  httpClient.get<WhitelistBankDetails[]>(`/whitelistBankDetails?memberId=${memberId}`)

export const updateWhitelistPaymentDetails = (data: UpdateWhitelistBankDetailsPayload) => {
  return httpClient.put<UpdateWhitelistBankDetailsPayload>('/whitelistBankDetails', data)
}
